import ProviderDetails from "../ProviderDetails";
import PlanLists from "../PlanLists";
import { ExternalContainer } from "../../../components/Account/reusables";
import { Header } from "../Header";

const AirtimePlan = () => {
  return (
    <div className="h-full  w-full  md:px-8">
      <ExternalContainer>
        <div>
          <Header />
          <div className="flex flex-col bp:flex-row items-start gap-6 lg:gap-12 mt-6">
            <ProviderDetails />
            <PlanLists productType="airtime" />
          </div>
        </div>
      </ExternalContainer>
    </div>
  );
};

export default AirtimePlan;
